module.exports = __webpack_public_path__ + "static/media/motion.e57b6094.png";